import styled from '@emotion/styled';
import { Container } from '@portalterreno/react-ui-core/Grid';

const StyledContainer = styled(Container)({}, ({ theme }) => ({
  backgroundColor: theme.palette.secondary
}));

export default StyledContainer;
